export default __webpack_public_path__ + "static/media/purpleFlower.07fd767b.jpg";